<template>

    <div class="col-md-2">
        <div class="panel panel-tile text-info light">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"/>

            <div class="panel-footer">
                    <span class="text-muted">
                        Безнал
                    </span>
                <span class="label label-success pn pl5 pr5 pull-right ">сегодня</span>

            </div>
            <div class="panel-body pn pl20 p5">

                <h2 class="mt15 lh15 fw300 counter card_today">
                    {{(sum !== false ? sum : '---') | numberFormat(0)}}
                </h2>
            </div>

        </div>
    </div>

</template>

<script>
    import Statistics from "../../../../classes/api/Statistics";
    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
        },
        async beforeMount() {
            this.isLoading = true;

            const sumRequest = await Statistics.getCard();
            this.sum = sumRequest.data.result;

            this.isLoading = false;
        },
        data: () => {
            return {
                isLoading: true,
                sum: false,
            };
        },
    };
</script>
